<template>
  <entity-list-table
    :title="title"
    :data-service="dataService"
    :headers="headers"
    :create-route-name="createRouteName"
    :edit-route-name="editRouteName"
    :allow-delete="allowDelete"
    :show-status-column="showStatusColumn"
  >
    <template v-slot:item.types="{ item }">
      {{ getTypesLabel(item.types) }}
    </template>
    <template v-slot:item.category="{ item }">
      <template v-if="item.category">
        {{ item.category.name }}
      </template>
    </template>
  </entity-list-table>
</template>

<script>

  import EntityListTable from '@/components/ui/crud/EntityListTable'
  import CollectionDataService from '@/services/api/CollectionDataService'
  import CollectionType from '@/models/enums/CollectionType'
  import _ from 'lodash'

  export default {
    components: { EntityListTable },
    data () {
      return {
        title: 'Подборки блюд',
        dataService: CollectionDataService,
        createRouteName: 'collectionsCreate',
        editRouteName: 'collectionsEdit',

        headers: [
          { text: 'ID', value: 'id', align: 'start' },
          { text: 'Название', value: 'name', align: 'start' },
          { text: 'Тип', value: 'types', align: 'start' },
          { text: 'Цель ', value: 'target', align: 'start' },
          { text: 'Категория', value: 'category', align: 'start' },

        ],

        allowDelete: true,
        showStatusColumn: true,
      }
    },
    methods: {
      getTypesLabel (types) {
        if (_.isEmpty(types)) {
          return ''
        }

        return types
          .map(item => {
            return CollectionType.getName(item)
          })
          .join(', ')
      },
    },
  }
</script>
